export default __webpack_public_path__ + "static/media/c-n-v-select.5c0afce8.svg";